import Box from '@mui/material/Box'

function CustomBox(props) {
  return <Box {...props} />
}
export default CustomBox
